const WHATSAPP_E164 = '50422834540';

function whatsappUrl(message?: string): string {
  const base = `https://wa.me/${WHATSAPP_E164}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}

/** Número de WhatsApp de la página. Un cambio aquí actualiza enlaces y textos. */
export const WHATSAPP = {
  display: '+504 2283-4540',
  local: '2283-4540',
  parenthesized: '(504)2283-4540',
  url: whatsappUrl,
};
